












import Vue from 'vue';
import Component from 'vue-class-component';

/**
 *  General loader.
 */
@Component
export default class Loader extends Vue {}
